<template>
  <div>
    <div class="channel-top">
      <i-row style="width:100%">
        <i-col :xs="24" :sm="24" :md="18" :lg="20" class="channel-search" style="margin:8px 0">
          <i-input
            placeholder="模糊搜索"
            style="width: 200px;margin: 0 auto;"
            v-model="filterData.search.search_key"
            clearable
            @on-clear="searchKeyClear"
            @keyup.enter.native="searchBth()"
          />
          <i-button type="info" icon="md-search" class="search" @click="searchBth()">搜索</i-button>
        </i-col>
        <i-col :xs="24" :sm="24" :md="6" :lg="4" style="margin:8px 0">
          <i-button type="success" class="article-button" style="margin: 0 auto;" @click="isTemplate">
            <i class="iconfont icon-tianjia operate-icon"></i>
            新增
          </i-button>
        </i-col>
      </i-row>
    </div>
    <div class="channel-main">
      <i-table
        class="channel-table"
        :columns="finalColumns"
        :data="channelData"
        @on-filter-change="filter"
        @on-sort-change="sortChange"
        ref="table"
        stripe
        border
      >
        <!-- 属性 -->
        <template slot="channel_attributes" slot-scope="{ row }">
          <span v-for="(item, index) in row.channel_attributes" :key="index">
            <a @click="toAttributePage(item.name)">{{ item.name }}</a>
            <span v-if="index < row.channel_attributes.length - 1">,</span>
          </span>
        </template>
        <!-- 属性 -->
        <template slot="attributes" slot-scope="{ row }">
          <span v-for="(item, index) in row.attributes" :key="index">
            <a @click="toAttributePage(item.name)">{{ item.name }}</a>
            <span v-if="index < row.attributes.length - 1">,</span>
          </span>
        </template>
        <!-- 可用模板 -->
        <template slot="templates" slot-scope="{ row }">
          <span v-for="(item, index) in row.templates" :key="index">
            <a @click="toTemplatePage(item.name)">{{ item.name }}</a>
            <span v-if="index < row.templates.length - 1">,</span>
          </span>
        </template>
        <!-- 允许新增和删除 -->
        <template slot="allowCreate" slot-scope="{ row }">
          <i-switch v-model="row.allowCreate" @on-change="allowCreateChange(row)" />
          {{ row.allowCreate ? "是" : "否" }}
        </template>
        <!-- 单文章频道 -->
        <template slot="isArticle" slot-scope="{ row }">
          {{ row.isArticle ? "是" : "否" }}
        </template>
        <!-- 是否自由编辑 -->
        <template slot="isFree" slot-scope="{ row }">
          <i-switch v-model="row.isFreeEdit" @on-change="freeEditChange(row)" />
          {{ row.isFreeEdit ? "是" : "否" }}
        </template>
        <!-- 是否禁用 -->
        <template slot="isForbid" slot-scope="{ row }">
          <i-switch v-model="row.disable" :trueValue2="false" :falseValue2="true" @on-change="disableChange(row)" />
          {{ row.disable ? "是" : "否" }}
        </template>
        <!-- 操作 -->
        <template slot="operate" slot-scope="{ row }">
          <i-button type="warning" class="article-button" @click="updateChannel(row)">
            <i class="iconfont icon-weibiaoti2010104 operate-icon"></i>
            编辑
          </i-button>
        </template>
      </i-table>
      <!-- 分页器 -->
      <i-page
        :total="total"
        :page-size-opts="[10, 20, 30, 40, 50, 100]"
        size="small"
        show-elevator
        show-sizer
        show-total
        placement="top"
        :current="current"
        :page-size="pageSize"
        @on-change="pageChange"
        @on-page-size-change="pageSizeChange"
      />
    </div>
    <!-- loading-->
    <div v-if="showLoading" class="demo-spin-col" span="8">
      <i-spin fix>
        <i-icon type="ios-loading" size="18" class="demo-spin-icon-load"></i-icon>
        <div>Loading</div>
      </i-spin>
    </div>
    <!-- 更新模板的模态框 -->
    <update-channel
      :show-modal="showUpdateChannelModal"
      :id="updateId"
      :name="updateName"
      :english-name="updateEnglishName"
      :desc="updateDesc"
      :attr="updateAttr"
      :tmp="updateTemp"
      :init-channel-attr="updateChannelAttr"
      :init-channel-attr-data="channelAttrData"
      @cancelModal="cancel"
      @success="success"
    ></update-channel>
    <!-- 增加频道模态框 -->
    <add-channel :show-modal="showAddChannelModal" @cancelModal="cancel" @success="success"></add-channel>
  </div>
</template>

<script>
import UpdateChannel from "./Channel/UpdateChannel.vue"
import AddChannel from "./Channel/AddChannel.vue"
import { baseConfigMixin } from "./mixin"
export default {
  name: "Channel",
  components: {
    UpdateChannel,
    AddChannel,
  },
  mixins: [baseConfigMixin],
  data() {
    return {
      showAddChannelModal: false, //是否显示添加模板弹窗
      showUpdateChannelModal: false, //是否显示更新频道弹窗
      updateId: "",
      updateName: "",
      updateEnglishName: "",
      updateDesc: "",
      updateAttr: [],
      updateTemp: [],
      updateChannelAttr: [],
      channelAttrData: {},
      total: 10,
      current: 1,
      pageSize: null,
      columns: [
        {
          type: "selection",
          width: 30,
          align: "center",
          resizable: true,
        },
        {
          title: "名称",
          key: "name",
          width: 150,
          align: "center",
          resizable: true,
        },
        {
          title: "简介",
          key: "desc",
          minWidth: 150,
          align: "center",
          resizable: true,
        },
        {
          title: "频道属性",
          key: "channel_attributes",
          slot: "channel_attributes",
          minWidth: 150,
          align: "center",
          resizable: true,
        },
        {
          title: "属性",
          key: "attributes",
          slot: "attributes",
          minWidth: 150,
          align: "center",
          resizable: true,
        },
        {
          title: "可用模板",
          key: "templates",
          slot: "templates",
          minWidth: 150,
          align: "center",
          resizable: true,
        },
        {
          title: "允许新增和删除",
          key: "allowCreate",
          slot: "allowCreate",
          width: 180,
          align: "center",
          resizable: true,
        },
        {
          title: "单文章频道",
          key: "isArticle",
          slot: "isArticle",
          width: 100,
          align: "center",
          resizable: true,
        },
        {
          title: "自由编辑",
          key: "isFreeEdit",
          slot: "isFree",
          width: 100,
          align: "center",
          resizable: true,
          filterKey: "is_free_edit",
          filters: [
            {
              label: "是",
              value: "true",
            },
            {
              label: "否",
              value: "false",
            },
          ],
          filterMethod() {
            return true
          },
        },
        {
          title: "是否禁用",
          key: "disable",
          slot: "isForbid",
          width: 100,
          align: "center",
          resizable: true,
          filterKey: "disable",
          filters: [
            {
              label: "是",
              value: "true",
            },
            {
              label: "否",
              value: "false",
            },
          ],
          filterMethod() {
            return true
          },
        },
        {
          title: "操作",
          key: "operate",
          slot: "operate",
          width: 150,
          align: "center",
        },
      ],
      finalColumns: [],
      filterData: {
        // 是否自由编辑筛选参数
        isFreeEdit: {},
        // 禁用筛选参数
        disable: {},
        // 可用模板筛选参数
        status: {},
        // 搜索参数
        search: {
          search_key: "",
        },
      },
      showLoading: true,
      toolTip: "点击复制id",
      channelData: [],
      init: true,
      order_by: {},
      attrSortable: {},
      attrFilter: {},
    }
  },
  methods: {
    //获取筛选数据
    filter(col) {
      const self = this
      self.current = 1
      if (col.isChannelAttr) {
        this.attrFilter = {}
        if (col._filterChecked.length > 0) {
          this.attrFilter[col.key] = col._filterChecked
        }
      } else {
        let filterChecked = col._filterChecked
        if (filterChecked.length === 1) {
          self.filterData[col.key][col.filterKey] = filterChecked[0] === "true" ? 1 : 0
        } else {
          self.filterData[col.key][col.filterKey] = []
        }
      }
      self.getChannelList()
    },
    // 弹出下拉列表
    isTemplate() {
      this.showAddChannelModal = true
    },
    // 跳转模板详情界面
    toTemplatePage(name) {
      this.$router.push({ path: "/project/Template", query: { searchKey: name } })
    },
    // 跳转模板详情界面
    toAttributePage(name) {
      this.$router.push({ path: "/project/Attribute", query: { searchKey: name } })
    },
    cancel() {
      this.updateName = ""
      this.updateEnglishName = ""
      this.updateDesc = ""
      this.updateAttr = []
      this.updateTemp = []
      this.showAddChannelModal = false
      this.showUpdateChannelModal = false
    },
    //编辑频道
    updateChannel(row) {
      this.updateName = row.name
      this.updateDesc = row.desc
      this.updateAttr = []
      this.updateAttr.push(...row.attributes)
      this.updateTemp = []
      this.updateTemp.push(...row.templates)
      this.updateId = row.id
      this.updateChannelAttr = row.channel_attributes
      this.channelAttrData = row.channel_attr_data
      this.showUpdateChannelModal = true
    },
    // page改变事件
    pageChange(index) {
      this.current = index
      this.getChannelList()
    },
    pageSizeChange(size) {
      this.pageSize = size
      localStorage.setItem("pageSize", size)
      this.$store.commit("changePageSize", size)
      this.getChannelList()
    },
    // 搜索
    searchBth() {
      this.current = 1
      this.getChannelList()
    },
    searchKeyClear() {
      this.current = 1
      this.getChannelList()
    },
    //获取列表信息，在挂载的时候就进行获取
    async getChannelList() {
      let self = this
      self.showLoading = true
      let xData = {}
      let filterData = {}
      for (let k in self.filterData) {
        filterData = { ...filterData, ...self.filterData[k] }
      }
      xData = {
        //页码
        p: this.current,
        //每页记录数
        p_size: this.pageSize,
      }
      if (this.attrFilter && JSON.stringify(this.attrFilter) !== "{}") {
        xData["channel_attr_filter"] = this.attrFilter
      }
      if (this.attrSortable && JSON.stringify(this.attrSortable) !== "{}") {
        xData["channel_attr_sortable"] = this.attrSortable
      }
      try {
        const res = await self.axios({
          method: "get",
          url: this.cmsUrl + "api/content/channel/list",
          params: {
            ...xData,
            ...filterData,
          },
        })
        if (!res) {
          return
        }
        if (res.data.code === 0) {
          self.showLoading = false
          if (this.init) {
            this.init = false
            let add = []
            if (res.data.data.data.length > 0) {
              let channelAttributes = {}
              // 拿取channel attribute的配置
              let attrList = []
              res.data.data.data.forEach((itemData) => {
                for (let item in itemData.channel_attributes) {
                  if (attrList.indexOf(item) === -1) {
                    channelAttributes[itemData.channel_attributes[item].type] = itemData.channel_attributes[item]
                  }
                }
                for (let item in itemData.channel_attr_data) {
                  if (attrList.indexOf(item) === -1) {
                    attrList.push(item)
                    let isFile = false
                    let title = channelAttributes[item].name
                    if (item.indexOf("cms__file") !== -1) {
                      isFile = true
                    }
                    let config = {
                      title: title,
                      key: item,
                      minWidth: 120,
                      align: "center",
                      render: (h, params) => {
                        let content = ""
                        if (params.row.channel_attr_data[item]) {
                          content = params.row.channel_attr_data[item]
                          if (isFile) {
                            if (params.row.channel_attr_data[item]) {
                              content =
                                "<a href='" +
                                params.row.channel_attr_data[item] +
                                "' target='_blank'>" +
                                params.row.channel_attr_data[item] +
                                "</a>"
                            }
                          }
                        }
                        return h("span", {
                          domProps: {
                            innerHTML: content,
                          },
                        })
                      },
                      isChannelAttr: true,
                    }
                    if (channelAttributes[item].sortable) {
                      config["sortable"] = "custom"
                    }
                    if (item.indexOf("cms__enum") !== -1) {
                      let filters = []
                      for (let i = 0; i < channelAttributes[item].value.length; i++) {
                        filters.push({
                          label: channelAttributes[item].value[i],
                          value: channelAttributes[item].value[i],
                        })
                      }
                      config["filters"] = filters
                      config["filterMethod"] = function() {
                        return true
                      }
                    }
                    add.push(config)
                  }
                }
              })
            }
            let _columns = []
            _columns = JSON.parse(JSON.stringify(this.columns))
            _columns.splice(4, 0, ...add)
            this.finalColumns = []
            this.finalColumns.push(..._columns)
            _columns.forEach((item) => {
              if (item.filters) {
                item["filterMethod"] = function() {
                  return true
                }
              }
            })
          }
          this.channelData = res.data.data.data
          this.total = res.data.data.total
        } else {
          self.showLoading = false
          self.$Message.error("操作失败，错误原因：" + res.data.error_message)
        }
      } catch (err) {
        self.showLoading = false
        self.$Message.error("操作失败，错误原因：" + err)
      }
    },
    async allowCreateChange(row) {
      try {
        const allow_create = row.allowCreate ? 1 : 0
        const resp = await this.axios({
          method: "post",
          url: this.cmsUrl + "api/content/channel/edit",
          data: {
            cid: row.id,
            allow_create,
          },
        })
        if (resp.data.code === 0) {
          const msg = row.allowCreate ? "允许新增、删除" : "禁止新增、删除"
          this.$Message.success(msg)
        } else {
          this.showLoading = false
          this.$Message.error("操作失败，错误原因：" + resp.data.error_message)
        }
      } catch (err) {
        this.showLoading = false
        this.$Message.error("操作失败，错误原因：" + err)
      }
    },
    async freeEditChange(row) {
      try {
        const is_free_edit = row.isFreeEdit ? 1 : 0
        const resp = await this.axios({
          method: "post",
          url: this.cmsUrl + "api/content/channel/edit",
          data: {
            cid: row.id,
            is_free_edit,
          },
        })
        if (resp.data.code === 0) {
          const msg = row.isFreeEdit ? "启用自由编辑" : "关闭自由编辑"
          this.$Message.success(msg)
        } else {
          this.showLoading = false
          this.$Message.error("操作失败，错误原因：" + resp.data.error_message)
        }
      } catch (err) {
        this.showLoading = false
        this.$Message.error("操作失败，错误原因：" + err)
      }
    },
    async disableChange(row) {
      try {
        const disable = row.disable ? 1 : 0
        const resp = await this.axios({
          method: "post",
          url: this.cmsUrl + "api/content/channel/edit",
          data: {
            cid: row.id,
            disable,
          },
        })
        if (resp.data.code === 0) {
          const msg = row.disable ? "禁用成功" : "启用成功"
          this.$Message.success(msg)
        } else {
          this.showLoading = false
          this.$Message.error("操作失败，错误原因：" + resp.data.error_message)
        }
      } catch (err) {
        this.showLoading = false
        this.$Message.error("操作失败，错误原因：" + err)
      }
    },
    success() {
      this.init = true
      this.getChannelList()
    },
    sortChange(column) {
      this.order_by = {}
      this.attrSortable = {}
      if (column.order === "desc") {
        if (column.key.indexOf("cms__") !== -1) {
          this.attrSortable[`asc`] = [0]
          this.attrSortable[`field`] = [column.key]
        } else {
          this.order_by[`asc`] = [0]
          this.order_by[`field`] = [column.key]
        }
      } else if (column.order === "normal") {
        this.attrSortable = {}
        this.order_by = {}
      } else {
        if (column.key.indexOf("cms__") !== -1) {
          this.attrSortable[`asc`] = [1]
          this.attrSortable[`field`] = [column.key]
        } else {
          this.order_by[`asc`] = [1]
          this.order_by[`field`] = [column.key]
        }
      }
      this.getChannelList()
    },
  },
  mounted() {
    if (localStorage.pageSize === undefined) {
      this.pageSize = 10
    } else {
      this.pageSize = Number(localStorage.pageSize)
    }
    this.getChannelList()
  },
}
</script>

<style scoped>
.channel-top {
  margin-top: 10px;
  margin-bottom: 10px;
}
.title {
  text-align: center;
}
.channel-search {
  min-width: 302px;
}
.channel-search .search {
  margin-left: 20px;
}
.channel-main {
  padding: 0 20px;
}

.article-button {
  margin-right: 5px;
}
>>> .ivu-table-cell {
  padding: 5px !important;
}
>>> .ivu-tooltip-inner {
  border: 1px solid white;
}
.channel-table {
  overflow: visible !important;
}
.operate-icon {
  margin-right: 5px;
}
</style>

<style lang="scss">
/* 让modal居中 */
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal {
    top: 0;
  }
}
</style>
